import { render, staticRenderFns } from "./helpBox.vue?vue&type=template&id=18c9c44c"
import script from "./helpBox.vue?vue&type=script&lang=js"
export * from "./helpBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports